export default __webpack_public_path__ + "static/media/elaborate.2750f89d.jpg";